"use strict";
document.addEventListener("DOMContentLoaded", function () {
	var forms = document.querySelectorAll("form.needs-validation");
	if (forms) {
		forms.forEach(function (form) {
			form.addEventListener("submit", function (event) {
				var inputs = form.querySelectorAll("input, textarea, select");
				var formIsValid = true;

				if (inputs) {
					inputs.forEach(function (input) {
						var rules = input.dataset.rule ? input.dataset.rule.split(" ") : [];

						if (rules.length) {
							var inputIsValid = true;

							rules.forEach(function (rule) {
								if (rule === "required") {
									if (!input.value.trim()) {
										showError(input, form.dataset.errormessageRequired || "This field is required.");
										inputIsValid = false;
									}
								}

								if (rule === "email") {
									var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
									if (!emailPattern.test(input.value)) {
										showError(input, form.dataset.errormessageEmail || "Please enter a valid email address.");
										inputIsValid = false;
									}
								}

								if (rule.startsWith("minlength-")) {
									var minLength = parseInt(rule.split("-")[1], 10);
									if (input.value.length < minLength) {
										showError(input, form.dataset.errormessageMinlength || "Please enter at least ".concat(minLength, " characters."));
										inputIsValid = false;
									}
								}

								if (rule === "checked") {
									if (!input.checked) {
										showError(input, form.dataset.errormessageChecked || "This checkbox must be checked.");
										inputIsValid = false;
									}
								}
							});

							if (!inputIsValid) {
								formIsValid = false;
							} else {
								input.parentElement.classList.remove("has-error");
								var errorMsg = input.parentElement.querySelector(".error");
								if(errorMsg) errorMsg.innerHTML = '';
							}
						}
					});
				}

				if (!formIsValid) {
					event.preventDefault();
					event.stopImmediatePropagation();

					var firstError = form.querySelector('.has-error');
					if(firstError) {
						firstError.scrollIntoView({behavior: "smooth", block: "center"});
					}
				} else {
					console.log("Form is valid. Submitting...");
				}
			});
		});
	}

	function showError(input, message) {
		input.parentElement.classList.add("has-error");
		var errorEl = input.parentElement.querySelector(".error");
		if (errorEl) {
			errorEl.innerHTML = message;
		}
	}

	function mainNavDropdowns() {
		if (window.matchMedia("(max-width: 991px)").matches) {
			var _mainNavDropdowns = document.querySelectorAll(".has-children");
			var mobNav = document.querySelector(".mob-nav");
			if (_mainNavDropdowns) {
				_mainNavDropdowns.forEach(function (parent) {
					parent.addEventListener("click", function (event) {
						parent.classList.add("active");
						if (parent.classList.contains("active")) {
							mobNav.classList.add("back")
						} else {
							mobNav.classList.remove("back")
						}
					})
				})
			}
		}
	}

	mainNavDropdowns();
	var mobNavBackBtn = document.querySelector(".mob-nav__back");
	if (mobNavBackBtn) {
		mobNavBackBtn.addEventListener("click", function () {
			var activeDropdown = document.querySelector(".mob-nav .has-children.active");
			if (activeDropdown) {
				activeDropdown.classList.remove("active")
			}
			var mobNav = document.querySelector(".mob-nav");
			mobNav.classList.remove("back")
		})
	}// anchor link smooth scroll
	var anchorLinks = document.querySelectorAll("a[href^=\"#\"]:not([data-fancybox])");
	anchorLinks.forEach(function (link) {
		link.addEventListener("click", function (e) {
			var targetId = link.getAttribute("href").substring(1);
			var targetElement = document.getElementById(targetId);
			if (targetElement) {
				e.preventDefault();
				var headerOffset = document.querySelector(".header").offsetHeight;
				var elementPosition = targetElement.getBoundingClientRect().top;
				var offsetPosition = elementPosition + window.pageYOffset - headerOffset - 24;
				window.scrollTo({top: offsetPosition, behavior: "smooth"})
			}
		})
	});// remove .has-error class on input change
	var errorInputs = document.querySelectorAll("input, textarea");
	errorInputs.forEach(function (input) {
		input.addEventListener("input", function () {
			input.parentElement.classList.remove("has-error")
		});
		input.addEventListener("change", function () {
			input.parentElement.classList.remove("has-error")
		});
		input.addEventListener("keyup", function () {
			input.parentElement.classList.remove("has-error")
		})
	});
	Fancybox.bind("[data-fancybox]", {
		autoFocus: false,
		placeFocusBack: false,
		dragToClose: false,
		closeExisting: true,
		Thumbs: false,
		closeButton: false
	});
	var categoryCarousels = document.querySelectorAll(".categories-carousel");
	if (categoryCarousels) {
		categoryCarousels.forEach(function (carousel) {
			new Swiper(carousel, {
				slidesPerView: 4,
				spaceBetween: 24,
				navigation: {
					nextEl: carousel.querySelector(".slider-nav__btn--next"),
					prevEl: carousel.querySelector(".slider-nav__btn--prev")
				},
				pagination: {el: carousel.querySelector(".swiper-pagination"), clickable: true},
				scrollbar: {el: ".swiper-scrollbar", hide: false},
				breakpoints: {
					320: {slidesPerView: "auto"},
					576: {slidesPerView: "auto"},
					992: {slidesPerView: 3},
					1600: {slidesPerView: 4}
				},
				on: {
					init: function init() {
						var totalSlides = this.slides.length;
						var slidesPerView = this.params.slidesPerView;
						var sliderNav = carousel.querySelector(".slider-nav");
						if (totalSlides <= slidesPerView) {
							sliderNav.style.display = "none"
						} else {
							sliderNav.style.display = "flex"
						}
					}, resize: function resize() {
						var totalSlides = this.slides.length;
						var slidesPerView = this.params.slidesPerView;
						var sliderNav = carousel.querySelector(".slider-nav");
						if (totalSlides <= slidesPerView) {
							sliderNav.style.display = "none"
						} else {
							sliderNav.style.display = "flex"
						}
					}
				}
			})
		})
	}
	var featuredCarousels = document.querySelectorAll(".featured-products-carousel");
	if (featuredCarousels) {
		featuredCarousels.forEach(function (carousel) {
			new Swiper(carousel, {
				slidesPerView: 5,
				spaceBetween: 24,
				navigation: {
					nextEl: carousel.querySelector(".slider-nav__btn--next"),
					prevEl: carousel.querySelector(".slider-nav__btn--prev")
				},
				pagination: {el: carousel.querySelector(".swiper-pagination"), clickable: true},
				scrollbar: {el: ".swiper-scrollbar", hide: false},
				breakpoints: {
					320: {slidesPerView: "auto"},
					576: {slidesPerView: "auto"},
					992: {slidesPerView: 4},
					1600: {slidesPerView: 5}
				},
				on: {
					init: function init() {
						var totalSlides = this.slides.length;
						var slidesPerView = this.params.slidesPerView;
						var sliderNav = carousel.querySelector(".slider-nav");
						if (totalSlides <= slidesPerView) {
							sliderNav.style.display = "none"
						} else {
							sliderNav.style.display = "flex"
						}
					}, resize: function resize() {
						var totalSlides = this.slides.length;
						var slidesPerView = this.params.slidesPerView;
						var sliderNav = carousel.querySelector(".slider-nav");
						if (totalSlides <= slidesPerView) {
							sliderNav.style.display = "none"
						} else {
							sliderNav.style.display = "flex"
						}
					}
				}
			})
		})
	}
	var marquees = document.querySelectorAll(".partners__track");
	if (marquees) {
		marquees.forEach(function (marquee) {
			var marqueeContent = marquee.innerHTML;
			marquee.innerHTML += marqueeContent;
			var speed = 0.5;
			var offset = 0;
			var animate = function animate() {
				offset -= speed;
				if (offset <= -marquee.scrollWidth / 2) {
					offset = 0
				}
				marquee.style.transform = "translateX(".concat(offset, "px)");
				requestAnimationFrame(animate)
			};
			marquee.addEventListener("mouseenter", function () {
				speed = 0
			});
			marquee.addEventListener("mouseleave", function () {
				speed = 0.5
			});
			animate()
		})
	}
	var mobileMenuBtn = document.querySelector(".nav-toggle");
	var mobileMenu = document.querySelector(".mob-nav");
	var mobileMenuCloseBtn = document.querySelector(".mob-nav__close");
	if (mobileMenuBtn && mobileMenu && mobileMenuCloseBtn) {
		mobileMenuBtn.addEventListener("click", function () {
			mobileMenu.classList.add("active");
			disableScrollExcept(".mob-nav__content")
		});
		mobileMenuCloseBtn.addEventListener("click", function () {
			mobileMenu.classList.remove("active");
			enableScroll(".mob-nav__content")
		})
	}// click outside .mob-nav to close mobile menu
	window.addEventListener("click", function (e) {
		if (mobileMenu.classList.contains("active")) {
			var isClickInside = mobileMenu.contains(e.target) || mobileMenuBtn.contains(e.target);
			if (!isClickInside) {
				mobileMenu.classList.remove("active");
				enableScroll(".mob-nav__content");
				document.querySelector(".mob-nav__back").click()
			}
		}
	});// accordion functionality
	var accordions = document.querySelectorAll(".accordion-wrap");
	accordions.forEach(function (accordion) {
		var items = accordion.querySelectorAll(".accordion-item");
		items.forEach(function (item) {
			var header = item.querySelector(".accordion-item__head");
			var content = item.querySelector(".accordion-item__content");
			if (item.classList.contains("active")) {
				content.style.height = content.scrollHeight + "px"
			} else {
				content.style.height = 0 + "px"
			}
			header.addEventListener("click", function () {
				var openItem = accordion.querySelector(".accordion-item.active");
				if (openItem && openItem !== item) {
					openItem.classList.remove("active");
					openItem.querySelector(".accordion-item__content").style.height = 0 + "px"
				}
				item.classList.toggle("active");
				var content = item.querySelector(".accordion-item__content");
				if (item.classList.contains("active")) {
					content.style.height = content.scrollHeight + "px"
				} else {
					content.style.height = 0 + "px"
				}
			})
		})
	});
	var filters = document.querySelectorAll(".filter");
	if (filters) {
		filters.forEach(function (filter) {
			var toggle = filter.querySelector(".filter__selected");
			toggle.addEventListener("click", function () {
				filter.classList.toggle("active")
			})
		})
	}// close filter__selected when clicking outside
	window.addEventListener("click", function (e) {
		filters.forEach(function (filter) {
			var toggle = filter.querySelector(".filter__selected");
			if (!toggle.contains(e.target)) {
				filter.classList.remove("active")
			}
		})
	});
	var galleries = document.querySelectorAll(".product-gallery");
	if (galleries) {
		galleries.forEach(function (gallery) {
			var mainImages = gallery.querySelectorAll(".product-gallery__main img");
			var thumbnails = gallery.querySelectorAll(".product-gallery__thumb");
			thumbnails.forEach(function (thumbnail, x) {
				thumbnail.addEventListener("click", function () {
					thumbnails.forEach(function (thumb) {
						thumb.classList.remove("active")
					});
					thumbnail.classList.add("active");
					mainImages.forEach(function (img, i) {
						if (i === x) {
							img.classList.add("active")
						} else {
							img.classList.remove("active")
						}
					})
				})
			})
		})
	}// disable letters in phone input.  only numbers, plus, brackets, and dashes allowed
	var phoneInputs = document.querySelectorAll("input[type=\"tel\"]");
	phoneInputs.forEach(function (input) {
		input.addEventListener("input", function () {
			input.value = input.value.replace(/[^\d+\-\(\)\s]/g, "")
		})
	})
});// is window scrolled? change header class
window.addEventListener("scroll", function () {
	var header = document.querySelector(".header");
	if (window.scrollY > 0) {
		header.classList.add("scrolled")
	} else {
		header.classList.remove("scrolled")
	}
});

function disableScrollExcept(allowedSelector) {
	var allowed = document.querySelector(allowedSelector);
	document.body.style.overflow = "hidden";
	document.body.style.position = "relative";
	document.body.style.touchAction = "none";
	if (allowed) {
		allowed.style.overflow = "auto";
		allowed.style.touchAction = "auto"
	}
}

function enableScroll(allowedSelector) {
	var allowed = document.querySelector(allowedSelector);
	if (allowed) {
		allowed.style.overflow = "";
		allowed.style.touchAction = ""
	}
	document.body.style.overflow = "";
	document.body.style.position = "";
	document.body.style.touchAction = ""
}// set css variable for header height
function setHeaderHeightVariable() {
	var header = document.querySelector(".header");
	if (header) {
		document.documentElement.style.setProperty("--header-height", "".concat(header.offsetHeight, "px"))
	}
}

window.addEventListener("load", setHeaderHeightVariable);
window.addEventListener("resize", setHeaderHeightVariable);
//# sourceMappingURL=app.js.map
